import * as form from '../form';

export const citizenshipAdditional = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Country: form.country(xitem.Country),
        CitizenshipStartDate:form.datecontrol(xitem.CitizenshipStartDate),
        CitizenshipEndDate:form.datecontrol(xitem.CitizenshipEndDate),
        EverIssuedPassport: form.branch(xitem.EverIssuedPassport),
        IsPassportActive: form.branch(xitem.IsPassportActive),
      },
    };
  });
  return {
    HasAdditionalCitizenship: form.branch(data.HasAdditionalCitizenship),
    List: form.collection(items, (data.List || {}).branch),
  };
};
